//
//
//
//
//
//
//
//
//
//
//

import api from '../apis/recentDiscussionsApi';

export default {
    name: 'DiscussionsWidget',
    props: {
        communityId: String,
        title: String
    },
    data() {
		return {
            discussions: []
        }
	},
    async created() {
        api.getRecentDiscussionsByCommunity(this.communityId)
            .then(resp => this.discussions = resp.data);
	}
}
